import { all, delay, put, takeLatest } from 'redux-saga/effects';
import { find, equals } from 'ramda';

import { SnackbarTypes, SnackbarActions } from './snackbar.redux';
import { SNACKBAR_NAMES } from './snackbar.constants';

function* handleSnackbar({ name, timeout = 3000 }) {
  if (!name || !find(equals(name), SNACKBAR_NAMES)) {
    return;
  }

  yield delay(timeout);
  yield put(SnackbarActions.hideSnackbar());
}

export default function* startupSaga() {
  yield all([takeLatest([SnackbarTypes.SHOW_SNACKBAR, SnackbarTypes.HIDE_SNACKBAR], handleSnackbar)]);
}
